import * as Sentry from '@sentry/react';

import { ApiError } from '@/error-handler/ApiError';
import { ClientError } from '@/error-handler/ClientError';

import type { CaptureExceptionOptions, SynclyError } from './types';

/**
 * 에러를 Sentry에 캡쳐
 * - ApiError: client_code로 그룹핑
 * - ClientError: error_code로 그룹핑
 * - 일반 Error: 기본 처리
 */
export function captureException(
  error: SynclyError,
  options?: CaptureExceptionOptions,
): string {
  return Sentry.captureException(error, (scope) => {
    // ApiError 처리
    if (error instanceof ApiError) {
      scope.setFingerprint(['api-error', error.data.client_code]);
      scope.setTag('error.type', 'api');
      scope.setTag('api.client_code', error.data.client_code);
      scope.setTag('api.status_code', String(error.code));
    }
    // ClientError 처리
    else if (error instanceof ClientError) {
      scope.setFingerprint(['client-error', error.client_error_code]);
      scope.setTag('error.type', 'client');
      scope.setTag('client.error_code', error.client_error_code);
    }
    // 일반 Error
    else {
      scope.setTag('error.type', 'standard');
    }

    // 옵션 처리
    if (options?.tags) {
      scope.setTags(options.tags);
    }
    if (options?.extra) {
      scope.setExtras(options.extra);
    }
    if (options?.level) {
      scope.setLevel(options.level);
    }

    return scope;
  });
}
